import { Stack, CircularProgress, Typography } from "@mui/material";

interface Props {
  updating: boolean;
  heading: string;
}

export const HeaderWithLoadingIndicator = ({ updating, heading }: Props) => {
  return (
    <Stack
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      sx={{ pt: 2, px: 4 }}
    >
      <Typography variant="button" component={"p"}>
        {heading}
      </Typography>

      {updating && (
        <Stack direction={"row"} alignItems={"center"} sx={{ mr: "24px" }}>
          <CircularProgress size={"24px"} sx={{ mr: "8px" }} />
          <Typography>Saving...</Typography>
        </Stack>
      )}
    </Stack>
  );
};
